import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateArrayState, updateObjectState } from "../utils";

const useRequestStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      updateNewCompany: (action, param) => set({ newCompany: updateObjectState(get().newCompany, action, param) }),
      updateNewBrand: (action, param) => set({ newBrand: updateObjectState(get().newBrand, action, param) }),
      updateNewShop: (action, param) => set({ newShop: updateObjectState(get().newShop, action, param) }),
      updateNewUser: (action, param) => set({ newUser: updateObjectState(get().newUser, action, param) }),
      updateRequestsCache: (action, query, param) => {
        set({ requestsCache: updateObjectState(get().requestsCache, action, { [query]: param }) });
      },
      /**
       * @param {string} action - The action to perform on the cache. Possible values: "whole" "update" "delete"
       * @param {Array} param - An array containing the request object(s) to be added, updated, or deleted.
       */
      updateSingleRequestCache: (action, param) => {
        set({ singleRequestCache: updateArrayState(get().singleRequestCache, action, param) });
      },
      resetRequest: () => set(initialState), // Reset function
      //getter
      getRequests: (query) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return [obj] if has cache of provided query
        return get().requestsCache[query];
      },
      getSingleRequest: (id) => {
        //return undefined if no cache, need axios
        //return [] if has cache but it is empty
        //return obj if has cache of provided id
        if (!id) {
          return undefined;
        }
        return get().singleRequestCache.find((e) => e.id === id);
      },
    })),
    {
      name: "pearl-request", //name of store, must be unique
      //storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useRequestStore;
